import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/eng/developments`;
const DOCS = `${process.env.REACT_APP_BACKEND_URL}/api/dms/linked/development_project`;
const ROOT = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEARN = `${process.env.REACT_APP_BACKEND_URL}/api/eng/dev-learning`;
const INTEL = `${process.env.REACT_APP_BACKEND_URL}/api/eng/dev-intel`;

export const devApi = {
  meta: () => axios.get(`${API}/meta`).then((r) => r.data),
  dashboard: () => axios.get(`${API}/dashboard`).then((r) => r.data),
  list: (params) => axios.get(API, { params }).then((r) => r.data),
  detail: (id) => axios.get(`${API}/${id}`).then((r) => r.data),
  create: (b) => axios.post(API, b).then((r) => r.data),
  patch: (id, b) => axios.patch(`${API}/${id}`, b).then((r) => r.data),
  remove: (id, { confirm, reason }) =>
    axios.delete(`${API}/${id}`, { params: { confirm, reason } }).then((r) => r.data),
  restore: (id) => axios.post(`${API}/${id}/restore`).then((r) => r.data),
  advance: (id, b) => axios.post(`${API}/${id}/stage`, b).then((r) => r.data),
  forceStage: (id, b) => axios.post(`${API}/${id}/stage/force`, b).then((r) => r.data),
  addExtRef: (id, b) => axios.post(`${API}/${id}/external-refs`, b).then((r) => r.data),
  deleteExtRef: (id, refId) => axios.delete(`${API}/${id}/external-refs/${refId}`).then((r) => r.data),
  markSeen: (id, slot) => axios.post(`${API}/${id}/documents/seen`, { slot }).then((r) => r.data),
  aiDraft: (b) => axios.post(`${API}/ai-draft`, b).then((r) => r.data),
  aiRefine: (id, b) => axios.post(`${API}/${id}/ai-refine`, b).then((r) => r.data),
  print: (id) => axios.get(`${API}/${id}/print`).then((r) => r.data),
  // フェーズ2 — 必要部品計画と調達
  parts: (id) => axios.get(`${API}/${id}/parts`).then((r) => r.data),
  setBuildQty: (id, build_quantity) =>
    axios.patch(`${API}/${id}/build-quantity`, { build_quantity }).then((r) => r.data),
  addParts: (id, lines) => axios.post(`${API}/${id}/parts`, { lines }).then((r) => r.data),
  patchPart: (id, pid, b) => axios.patch(`${API}/${id}/parts/${pid}`, b).then((r) => r.data),
  deletePart: (id, pid) => axios.delete(`${API}/${id}/parts/${pid}`).then((r) => r.data),
  aiSuggestParts: (id, b) => axios.post(`${API}/${id}/parts/ai-suggest`, b).then((r) => r.data),
  createPartsRequest: (id, b) =>
    axios.post(`${API}/${id}/parts/parts-request`, b).then((r) => r.data),
  importPartMaterials: (id, pid) =>
    axios.post(`${API}/${id}/parts/${pid}/materials/import`).then((r) => r.data),
  undoDisposition: (id, pid, ipid, dispId, b) =>
    axios.post(`${API}/${id}/prototypes/${pid}/parts/${ipid}/disposition/${dispId}/undo`, b)
      .then((r) => r.data),
  masterSearch: (q) =>
    axios.get(`${ROOT}/shizai/parts-request/master-search`, { params: { q } }).then((r) => r.data),
  orderCategories: () => axios.get(`${ROOT}/shizai/order-categories`).then((r) => r.data),
  // フェーズ3 — 試作・検証・改訂
  prototypes: (id) => axios.get(`${API}/${id}/prototypes`).then((r) => r.data),
  createPrototype: (id, b) => axios.post(`${API}/${id}/prototypes`, b).then((r) => r.data),
  patchPrototype: (id, pid, b) => axios.patch(`${API}/${id}/prototypes/${pid}`, b).then((r) => r.data),
  deletePrototype: (id, pid) => axios.delete(`${API}/${id}/prototypes/${pid}`).then((r) => r.data),
  cancelPrototype: (id, pid, b) =>
    axios.post(`${API}/${id}/prototypes/${pid}/cancel`, b).then((r) => r.data),
  uncancelPrototype: (id, pid) =>
    axios.post(`${API}/${id}/prototypes/${pid}/uncancel`).then((r) => r.data),
  installCandidates: (id, pid) =>
    axios.get(`${API}/${id}/prototypes/${pid}/install-candidates`).then((r) => r.data),
  installParts: (id, pid, lines) =>
    axios.post(`${API}/${id}/prototypes/${pid}/install`, { lines }).then((r) => r.data),
  disposePart: (id, pid, ipid, b) =>
    axios.post(`${API}/${id}/prototypes/${pid}/parts/${ipid}/disposition`, b).then((r) => r.data),
  createValidation: (id, pid, b) =>
    axios.post(`${API}/${id}/prototypes/${pid}/validations`, b).then((r) => r.data),
  createRevision: (id, b) => axios.post(`${API}/${id}/revisions`, b).then((r) => r.data),
  timeline: (id) => axios.get(`${API}/${id}/timeline`).then((r) => r.data),
  readiness: () => axios.get(`${API}/readiness`).then((r) => r.data),
  // フェーズ4 — 完了と登録
  completion: (id) => axios.get(`${API}/${id}/completion`).then((r) => r.data),
  complete: (id, b) => axios.post(`${API}/${id}/complete`, b).then((r) => r.data),
  // R4 · 製品番号の案（既存の採番の続き。新しい体系は作らない）
  productNumberProposal: (id, like) => axios.get(`${API}/${id}/product-number-proposal`,
    { params: like ? { like } : {} }).then((r) => r.data),
  leftoverParts: (id, b) => axios.post(`${API}/${id}/leftover-parts`, b).then((r) => r.data),
  handover: (id) => axios.get(`${API}/${id}/handover`).then((r) => r.data),
  rollbackPreview: (id) => axios.get(`${API}/${id}/rollback`).then((r) => r.data),
  rollback: (id, b) => axios.post(`${API}/${id}/rollback`, b).then((r) => r.data),
  digest: () => axios.get(`${API}/readiness/digest`).then((r) => r.data),
  // フェーズ5 — 分析と見える化
  insights: (days) => axios.get(`${API}/insights`, { params: { days } }).then((r) => r.data),
  analytics: () => axios.get(`${API}/analytics`).then((r) => r.data),
  // フェーズ6 — 学びと意思決定支援
  learningDigest: (month) =>
    axios.get(`${LEARN}/digest`, { params: { month } }).then((r) => r.data),
  sendLearningDigest: (month) =>
    axios.post(`${LEARN}/digest/send`, null, { params: { month } }).then((r) => r.data),
  learningDigestLog: () => axios.get(`${LEARN}/digest/log`).then((r) => r.data),
  learningRecommendations: (params) =>
    axios.get(`${LEARN}/recommendations`, { params }).then((r) => r.data),
  trends: (months) => axios.get(`${LEARN}/trends`, { params: { months } }).then((r) => r.data),
  digestConfig: () => axios.get(`${LEARN}/digest/config`).then((r) => r.data),
  saveDigestConfig: (b) => axios.put(`${LEARN}/digest/config`, b).then((r) => r.data),
  dismissWarning: (b) => axios.post(`${LEARN}/recommendations/dismiss`, b).then((r) => r.data),
  restoreWarning: (b) => axios.post(`${LEARN}/recommendations/restore`, b).then((r) => r.data),
  costAnalytics: (months) => axios.get(`${INTEL}/costs`, { params: { months } }).then((r) => r.data),
  knowledgeSuggestions: (id) =>
    axios.get(`${INTEL}/knowledge`, { params: { development_id: id } }).then((r) => r.data),
  knowledgeDraft: (b) => axios.post(`${INTEL}/knowledge/draft`, b).then((r) => r.data),
  gallery: (id) => axios.get(`${API}/${id}/gallery`).then((r) => r.data),
  costs: (id) => axios.get(`${API}/${id}/costs`).then((r) => r.data),
  sendDigest: () => axios.post(`${API}/readiness/digest/send`).then((r) => r.data),
  repairDigestAttribution: () =>
    axios.post(`${API}/readiness/digest/repair-attribution`).then((r) => r.data),
  searchDocs: (q) =>
    axios.get(`${ROOT}/dms/documents`, { params: { q, limit: 8 } }).then((r) => r.data),
  // 書類は Document App が所有。既存の連携ハブをそのまま使う。
  lookupDocs: (id, q) => axios.get(`${DOCS}/${id}/lookup`, { params: { q } }).then((r) => r.data),
  attachDoc: (id, document_id, link_role) =>
    axios.post(`${DOCS}/${id}/attach`, { document_id, link_role }).then((r) => r.data),
  unlinkDoc: (id, linkId) => axios.delete(`${DOCS}/${id}/${linkId}`).then((r) => r.data),
  uploadDoc: (id, file, { title, doc_type, link_role, doc_profile_key }) => {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('title', title || '');
    fd.append('doc_type', doc_type || 'other');
    fd.append('link_role', link_role || '');
    fd.append('doc_profile_key', doc_profile_key || '');
    return axios.post(`${DOCS}/${id}/upload`, fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  designDocs: (id) => axios.get(`${API}/${id}/design-docs`).then((r) => r.data),
  addDesignDocPath: (id, b) =>
    axios.post(`${API}/${id}/design-docs/path`, b).then((r) => r.data),
  deleteDesignDoc: (id, linkId) =>
    axios.delete(`${API}/${id}/design-docs/${linkId}`).then((r) => r.data),
  departments: () => axios.get(`${ROOT}/departments`).then((r) => r.data),
  // 社員マスタ（設備を登録の担当者ピッカーと同じ口）
  employees: () => axios.get(`${ROOT}/employees`).then((r) => r.data),
  // 製造部門マスタ（mfg_items.departments / mfg_lots.department_id と同じ識別子）
  mfgDepartments: () => axios.get(`${ROOT}/mfg/departments`).then((r) => r.data),
  // 場所マスタ（製造管理の設置場所と同じ口）
  mfgLocations: () => axios.get(`${ROOT}/mfg/locations`).then((r) => r.data),
};

export const STAGE_TONE = {
  concept: 'neutral', parts_planning: 'info', procurement: 'info',
  prototype: 'warning', validation: 'warning', revision: 'warning', completed: 'success',
};

export const DOC_STATE_LABEL = { registered: '登録済み', unregistered: '未登録', updated: '更新あり' };

// 部品ステータス — 🟢在庫あり / 🟡手配が必要 / 🔴情報不足
export const PART_STATUS = {
  // 試作に載っている分は「もう手に入れた分」— 手配のボタンは出さない
  installed: { label: '投入済み', tone: 'success', dot: 'bg-teal-500' },
  available: { label: '在庫あり', tone: 'success', dot: 'bg-emerald-500' },
  procurement: { label: '手配が必要', tone: 'warning', dot: 'bg-amber-500' },
  missing_info: { label: '情報不足', tone: 'danger', dot: 'bg-rose-500' },
};

export const PART_SOURCE_LABEL = {
  mfg_item: '製造品目', eng_asset: '技術資産', unregistered: '未登録部品',
};

// 試作ステータス
export const PROTO_TONE = {
  building: 'neutral', testing: 'info', passed: 'success',
  passed_with_issues: 'warning', failed: 'danger', needs_revision: 'warning',
};

export const DISPOSITION_TONE = {
  returned: 'info', scrapped: 'danger', rework: 'warning', hold: 'neutral',
  reuse_other: 'success',
};

// 出典・証跡のジャンプ先（ドキュメントアプリの該当ページを開く）
export const docLink = (documentId, page) =>
  `/documents?open=${documentId}${page ? `&page=${page}` : ''}`;
